import axios from 'axios';

const service = axios.create({
    baseURL: 'https://dhskqnas.0lag.org/eryujewry-reuryerrr',
    timeout: 10000
});

// 请求拦截器：自动带上 token（不解包响应，接口方法里用 res.data 取 body）
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.token = token;
        }
        const authtoken = localStorage.getItem('auth_data');
        if (authtoken) {
            config.headers.authtoken = authtoken;
        }
        return config;
    },
    err => Promise.reject(err)
);

export default service;